module.exports = __webpack_public_path__ + "img/chord-label-G.da743869.png";